import { Amplify } from 'aws-amplify';
import awsExports from 'aws-exports';
import { BrowserRouter } from 'react-router-dom';

import AuthenticatedApp from 'authenticated-app';

import CustomAuthenticator from 'components/custom-authenticator';

Amplify.configure(awsExports);

function App(): JSX.Element {
  return (
    <CustomAuthenticator>
      {({ signOut, user }) => (
        <BrowserRouter>
          <AuthenticatedApp user={user} signOut={signOut} />
        </BrowserRouter>
      )}
    </CustomAuthenticator>
  );
}

export default App;
